import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";
import { CONTACT_EMAIL } from "@/lib/config";

const PARAS = [
  "Before I built IronRoot, I ran my own consulting business.",
  "No matter how organized I tried to be, I found myself constantly switching between apps, searching for documents, answering the same questions, and trying to remember what needed to happen next — I even took a bookkeeping course trying to figure it out!",
  "I realized I wasn't spending my time building my business — I was spending it managing it.",
  "That's when I started asking myself a simple question: What if one AI could handle all of this?",
  "Not just bookkeeping. An AI that helps you start your business, keeps your books organized, stores your important documents, reminds you of deadlines, answers your questions, and grows with your business every step of the way.",
  "That's why I built IronRoot. My goal has never been to create another bookkeeping app — I wanted to build the business partner I wish I'd had. One that's available 24/7 and helps entrepreneurs spend less time on administrative work and more time building the business they dreamed of, while saving them money.",
  "Thank you for trusting IronRoot to be part of your journey. I'm excited to help you build something incredible.",
];

export default function About() {
  const { user } = useAuth();
  const ctaTo = user ? "/dashboard" : "/register";

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-16" data-testid="about-page">
        <div className="text-center">
          <img src="/founder.jpg" alt="Kamery Bradshaw, Founder of IronRoot" className="w-36 h-36 rounded-full object-cover mx-auto shadow-lg" style={{ objectPosition: "center top" }} />
          <span className="block text-xs uppercase tracking-[0.22em] font-semibold mt-6" style={{ color: "var(--bk-accent)" }}>Our story</span>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-3" style={{ color: "var(--bk-text)" }}>
            A note from the founder
          </h1>
          <p className="text-base mt-4 max-w-xl mx-auto" style={{ color: "var(--bk-text-2)" }}>
            Built by an entrepreneur who's been exactly where you are.
          </p>
        </div>

        <div className="mt-10 space-y-5 text-[16px] leading-relaxed" style={{ color: "var(--bk-text-2)" }}>
          {PARAS.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          <p className="font-display text-xl font-semibold" style={{ color: "var(--bk-text)" }}>Welcome to IronRoot.</p>
        </div>

        <div className="flex items-center gap-4 mt-10 pt-6 border-t" style={{ borderColor: "var(--bk-border)" }}>
          <img src="/founder.jpg" alt="Kamery Bradshaw" className="w-16 h-16 rounded-full object-cover shrink-0" style={{ objectPosition: "center top" }} />
          <div>
            <p className="font-display text-2xl" style={{ color: "var(--bk-accent)", fontStyle: "italic" }}>Kamery Bradshaw</p>
            <p className="text-sm" style={{ color: "var(--bk-text-2)" }}>Founder, IronRoot</p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <Link to={ctaTo} data-testid="about-cta" className="bk-btn-energy inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-sm font-bold">
            {user ? "Go to dashboard" : "Start free today"} <ArrowRight size={18} weight="bold" />
          </Link>
          <p className="text-sm mt-5" style={{ color: "var(--bk-text-2)" }}>
            Questions? <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold hover:underline" style={{ color: "var(--bk-accent)" }}>{CONTACT_EMAIL}</a>
          </p>
        </div>
      </main>
    </div>
  );
}
